export default __webpack_public_path__ + "static/media/365-BizTool-Favicon-Light-Logo.5f33e276.png";